import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { settings, settingsStorePlugin } from './settings';
import { auth } from './auth';
import { log, logStorePlugin } from './log';
import { documents } from './documents';
import { organization } from './organization';
import { folders } from './folders';
import { sign, updateSignCloudProvidersPlugin } from './sign';
import { filefolders } from './filefolders';
import { userSettings } from './userSettings';
import { settingsTemp } from './settings.temp';
import { components } from './components';
import { modules } from './modules';
import { documentSignaturesTemp } from '@/store/document-signatures.temp';

Vue.use(Vuex);

const plugins: Array<any> = [];
if (navigator.cookieEnabled) {
  plugins.push(
    createPersistedState({
      key: 'AskodOnline',
      paths: ['settings', 'auth', 'log', 'documents', 'organization', 'folders', 'sign', 'components']
    })
  );
}
plugins.push(settingsStorePlugin);
plugins.push(logStorePlugin);
plugins.push(updateSignCloudProvidersPlugin);

export default new Vuex.Store({
  modules: {
    settings,
    auth,
    log,
    documents,
    organization,
    folders,
    sign,
    components,
    userSettings,
    filefolders,
    settingsTemp,
    modules,
    documentSignaturesTemp
  },
  plugins: plugins
});
